import { type RefObject, useEffect, useRef } from 'react';

const useOutsideClick = <T extends HTMLElement>(
  ref: RefObject<T | null>,
  callback: () => void,
  ignoreClasses: string[] = []
) => {
  const ignoreClassesJson = JSON.stringify(ignoreClasses);

  const callbackRef = useRef(callback);

  useEffect(() => {
    callbackRef.current = callback;
  });

  useEffect(() => {
    const handleClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const isIgnoreClass = JSON.parse(ignoreClassesJson).some(
        (ignoreClass: string) => {
          return target.classList.contains(ignoreClass);
        }
      );

      if (isIgnoreClass) {
        return null;
      }

      if (ref.current && !ref.current.contains(target)) {
        callbackRef.current();
      }

      return null;
    };

    document.addEventListener('click', handleClick);

    return () => {
      document.removeEventListener('click', handleClick);
    };
  }, [ref, ignoreClassesJson]);
};

export default useOutsideClick;
